import { render, staticRenderFns } from "./CardHorizontal.vue?vue&type=template&id=4b9ff672"
import script from "./CardHorizontal.vue?vue&type=script&lang=js"
export * from "./CardHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PostMeta: require('/opt/build/repo/components/post/Meta.vue').default})
